import { useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const Newsletter = ({ compact = false }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      setDone(true);
      setEmail("");
      toast.success("Subscribed! Check your inbox.");
    } catch {
      toast.error("Could not subscribe. Please try again.");
    }
    setLoading(false);
  };

  return (
    <section
      aria-label="Newsletter subscription"
      data-testid="newsletter"
      className={`rounded-2xl bg-secondary/10 border border-secondary/20 p-6 ${compact ? "" : "text-center"}`}
    >
      <Mail className="w-7 h-7 text-secondary mx-auto mb-2" aria-hidden="true" />
      <h3 className="font-display font-bold text-lg">Join Xurray Journal</h3>
      <p className="text-sm text-muted-foreground mt-1 mb-4">Get our best stories on African food, culture & style — free, straight to your inbox.</p>
      {done ? (
        <p className="text-sm font-medium text-green-600" data-testid="newsletter-success">🎉 You're subscribed. Welcome aboard!</p>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2">
          <label htmlFor="nl-email" className="sr-only">Email address</label>
          <Input
            id="nl-email"
            type="email"
            required
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex-1"
            data-testid="newsletter-email"
          />
          <Button type="submit" disabled={loading} className="rounded-full" data-testid="newsletter-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Subscribe"}
          </Button>
        </form>
      )}
    </section>
  );
};
